module.exports = __webpack_public_path__ + "img/爆款美妆特惠.95db99ad.png";